import { defineMessages } from '@atlassian/jira-intl';

export const messages = defineMessages({
	closeSidebar: {
		id: 'polaris-ideas.right-sidebar.view-info.header.close-sidebar',
		defaultMessage: 'Close sidebar',
		description: 'Label for the cross icon button that closes the sidebar',
	},
});
